/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // filter items on button click
        $('#filters').on( 'click', 'button', function() {
          var filterValue = $(this).attr('data-filter');
          $('.ressources-wrapper').isotope({ filter: filterValue, transitionDuration: 0 });
        });

        var recrutementForm = document.getElementById('recrutement-form');
        if (recrutementForm) {
          var dataJob = document.querySelectorAll('[data-job]');
          var inputjob = recrutementForm.querySelector('input[name="_job"]');

          dataJob.forEach(function(child) {
            child.addEventListener('click', function() {
              inputjob.value = child.getAttribute("data-job");
            });
          });

          var inputFile = document.querySelectorAll('input[type=file]');
          inputFile.forEach(function(input) {
            input.addEventListener('change', function(e) {
              var file = e.target.files[0].name;
              input.parentNode.parentNode.querySelector('.custom-file-label').innerHTML = file;
            });
          });
        }

      //   var jobsList = document.querySelector('.job-list');
      //   var jobsHead = document.querySelector('.job-head');
      //   var jobItems = document.querySelectorAll('.job-item[data-job-item]');
      //   var jobContents = document.querySelectorAll('.job-content[data-job-item]');
      //   var backToJobs = document.querySelector('.back-to-jobs');

      //   if(jobItems) {
      //   jobItems.forEach(function(item) {
      //     item.addEventListener('click', function(e) {
      //       e.preventDefault();
      //       var target = item.getAttribute('data-job-item');
      //       jobContents[target].classList.add('active');
      //       jobsHead.classList.remove('active');
      //       jobsList.classList.remove('active');
      //       backToJobs.classList.add('active');
      //     });
      //   });
      // }

      //   if(backToJobs) {
      //   backToJobs.addEventListener('click', function(e) {
      //     e.preventDefault();
      //     var jobContentActive = document.querySelector('.job-content.active');
      //     jobContentActive.classList.remove('active');
      //     jobsHead.classList.add('active');
      //     jobsList.classList.add('active');
      //     backToJobs.classList.remove('active');
      //   });
      // }
      

        if (window.matchMedia("(min-width: 1200px)").matches) {
        var controller = new ScrollMagic.Controller();

        // Service section with macbook image
        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-left",
          triggerHook: 0.4, // show, when scrolled 10% into view
          offset: 50 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-left .background-mask", "hidden")
        .reverse(false)
        .addTo(controller);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-left",
          triggerHook: 0.4, // show, when scrolled 10% into view
          offset: 50 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-left .parallax-wrapper", "visible")
        .reverse(false)
        .addTo(controller);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-left",
          triggerHook: 0.4, // show, when scrolled 60% into view
          offset: 50 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-left .section-wrapper", "visible")
        .reverse(false)
        .addTo(controller);


        TweenLite.defaultEase = Linear.easeNone;
        var tl = new TimelineMax();
        tl.to(".mac-content img", 1, {x:0, y:0, z:0}, 0);
        tl.to(".mac-content img", 1, {x:0, y:-300, z:0}, 0);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-left",
          duration: "100%",
          triggerHook: 0.3
        })
        .setTween(tl)
        .addTo(controller);


        // Service section with ipad image
        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-right",
          triggerHook: 0.5, // show, when scrolled 10% into view
          offset: 0 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-right .background-mask", "hidden")
        .reverse(false)
        .addTo(controller);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-right",
          triggerHook: 0.5, // show, when scrolled 10% into view
          offset: 0 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-right .parallax-wrapper", "visible")
        .reverse(false)
        .addTo(controller);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-right",
          triggerHook: 0.5, // show, when scrolled 60% into view
          offset: 0 // move trigger to center of element
        })
        .setClassToggle(".parallax-section.image-right .section-wrapper", "visible")
        .reverse(false)
        .addTo(controller);


        var tl2 = new TimelineMax();
        tl2.to(".ipad-content img", 1, {x:0, y:0, z:0}, 0);
        tl2.to(".ipad-content img", 1, {x:0, y:-300, z:0}, 0);

        new ScrollMagic.Scene({
          triggerElement: ".parallax-section.image-right",
          duration: "100%",
          triggerHook: 0.3,
          offset: -100
        })
        .setTween(tl2)
        .addTo(controller);
      }


        // ScrollReveal().reveal('.parallax-wrapper.mac', { delay: 800, origin: 'left', distance: '150px', duration: 1500 });
        // ScrollReveal().reveal('.parallax-section .background-wrapper .background-mask', { origin: 'bottom', distance: '100%', duration: 1500 });
        // ScrollReveal().reveal('.parallax-section .section-wrapper', { origin: 'right', distance: '150px', duration: 1500 });


        var services = document.querySelectorAll('.services-item');

        if (services != null) {
          for(var i = 0; i < services.length; i++) {
            services[i].addEventListener('mousemove', function(e) {
              var rect = e.target.parentNode.getBoundingClientRect();
              var x = e.clientX - rect.left;
              var y = e.clientY - rect.top;

              e.target.parentNode.style.setProperty('--x', x + 'px');
              e.target.parentNode.style.setProperty('--y', y + 'px');
            });
          }
        }

        var burger = $('.navbar .burger .navbar-toggler');
        var navbarCollapse = $('.navbar .navbar-collapse');
        burger.on('click', function() {
          navbarCollapse.toggleClass('is-active');
          navbar.toggleClass('is-active');
          $('body').toggleClass('no-scroll');
        });

        var navbar = $('.navbar');
        $('.menu > .menu-item-has-children > a').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          if($(this).parent().hasClass('is-active')) {
            $(this).parent().toggleClass('is-active')
            $(this).parent().find('.sub-menu').toggleClass('is-active')
            $('body').removeClass('filter');
            if (!$('.navbar-collapse').hasClass('is-active')) {
              navbar.removeClass('is-active');
            }
            return;
          }

          if (!navbar.hasClass('is-active')) {
            navbar.toggleClass('is-active');
          }
          $('.menu > li.is-active').find('.sub-menu').toggleClass('is-active')
          $('.menu > li.is-active').toggleClass('is-active')

          $('body').addClass('filter');
          $(this).parent().toggleClass('is-active')
          $(this).parent().find('.sub-menu').toggleClass('is-active')
        })


        var headerHeight = $('#header').height();
        $(window).resize(function() {
          headerHeight = $('#header').height();
        });

        var navbarIsFixed = false;
        $(window).scroll(function() {
          if (this.scrollY >= headerHeight && !navbarIsFixed) {
            navbar.addClass('is-fixed');
            navbarIsFixed = true;
          } else if (this.scrollY < headerHeight && navbarIsFixed) {
            navbar.removeClass('is-fixed');
            navbarIsFixed = false;
          }
        });

        // Back to top
        var backToTop = $('#backToTop');
        var backToTopIsActive = false;
        $(window).scroll(function() {
          var scrollPercent = (this.scrollY) / ($(document).height() - this.innerHeight);
          var scrollPercentRounded = Math.round(scrollPercent * 100);

          if (scrollPercentRounded >= 60 && !backToTopIsActive) {
            backToTop.addClass('is-active');
            backToTopIsActive = true;
          } else if (scrollPercentRounded < 60 && backToTopIsActive) {
            backToTop.removeClass('is-active');
            backToTopIsActive = false;
          }
        });

        $('.slider-navigation .previous, .slider-navigation .next').on('click', function() {
          var target = $(this).parent().data('target');
          var value = $(this).data('value');

          var slider = $('.' + target);
          var slidesNb = slider.find('.slick-slide').length;
          var index = slider.slick('slickCurrentSlide');
          var slidesToShow = slider.slick('slickGetOption', 'slidesToShow');

          if (value === 'previous' && index > 0) {
            slider.slick('slickPrev');
          } else if (value === 'previous' && index === 0) {
            slider.slick('slickGoTo', slidesNb - slidesToShow);
          }
          if (value === 'next' && index < slidesNb - slidesToShow) {
            slider.slick('slickNext');
          } else if (value === 'next' && index === slidesNb - slidesToShow) {
            slider.slick('slickGoTo', 0);
          }
        });

        // Smooth Scroll Anchor
        $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {

              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 1000, function() {

                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) {
                  return false;
                } else {
                  $target.attr('tabindex','-1');
                  $target.focus();
                }
              });
            }
          }
        });

        $('#blog .blog-slider').slick({
          dots: false,
          autoplay: true,
          infinite: true,
          arrows: false,
          speed: 600,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
            }
          }
          ]
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'projets': {
      init: function() {
        // JavaScript to be fired on the home page
        var $portfolio = $('.portfolio').isotope({
          itemSelector: '.portfolio-item',
          percentPosition: true,
          getSortData: {
            category: '[data-category]'
          },
          masonry: {
            columnWidth: 398,
            gutter: 16,
          },
          hiddenStyle: {
            opacity: 0,
          },
          visibleStyle: {
            opacity: 1,
          }
        });

        // bind filter button click
        $('#filters').on( 'click', 'button', function() {
          var filterValue = $( this ).attr('data-filter');
          $portfolio.isotope({ filter: filterValue });
        });

        // change is-active class on buttons
        $('.button-group').each( function( i, buttonGroup ) {
          var $buttonGroup = $( buttonGroup );
          $buttonGroup.on( 'click', 'button', function() {
            $buttonGroup.find('.is-active').removeClass('is-active');
            $( this ).addClass('is-active');
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Equipe Webidea
    'les_membres_de_lagence': {
      init: function() {

        $('#team .team-slider').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         fade: true,
         asNavFor: '#team .team-list',
       });

        $('#team .team-list').slick({
          autoplay: false,
          slidesToShow: 7,
          slidesToScroll: 1,
          // dots: true,
          arrows: true,
          focusOnSelect: true,
          autoplaySpeed: 7000,
          asNavFor: '#team .team-slider',
          responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 6,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          }
          ]
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'contactez_lagence': {
      init: function() {

        // Map location
        var data = [{
          lat: 49.114254,
          lon: 6.176980,
          zoom: 13,
          icon: '/app/themes/agencewebidea/dist/images/marker-webidea.png',
        }];

        // Contact map
        new Maplace({
          map_options: {
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
          },
          locations: data,
          styles:{Greyscale:[{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#444444"}]},{featureType:"administrative.country",elementType:"geometry.fill",stylers:[{visibility:"on"}]},{featureType:"administrative.country",elementType:"labels.text",stylers:[{color:"#0e7cc6"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f2f2f2"}]},{featureType:"landscape.natural.terrain",elementType:"geometry.fill",stylers:[{color:"#8a5600"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#00C3F2"},{visibility:"on"}]}]},
        }).Load();

        // document.addEventListener( 'wpcf7mailsent', function( event ) {
        //   ga( 'send', 'event', 'Contact Form', 'submit' );
        // }, false );

      },
      finalize: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.